import resume from "../assets/pdf/Mahammadayan_Shaikh_Resume.pdf";

function Resume() {
  return <embed className="mt-4" src={resume} width="100%" height="750"></embed>;
}

export default Resume;
